import {deferToIdle} from '../utils/deferToIdle.js';

/**
 * A behavior that handles dropdown menu functionality
 */
export function initDropdown() {
    const dropdowns = document.querySelectorAll('[data-dropdown]');

    // Store dropdown elements for easy access
    const dropdownMap = new Map();

    dropdowns.forEach(container => {
        const trigger = container.querySelector('[data-dropdown-trigger]');
        const content = container.querySelector('[data-dropdown-content]');

        if (!trigger || !content) return;

        // Store dropdown elements in the map
        dropdownMap.set(container, {trigger, content});

        // Function to toggle dropdown
        const toggleDropdown = (event) => {
            // Let modified clicks (cmd/ctrl/shift-click) pass through so anchor triggers can open in a new tab/window.
            if (event.metaKey || event.ctrlKey || event.shiftKey) return;
            event.preventDefault();
            event.stopPropagation();
            const isHidden = content.classList.toggle('hidden');

            // Update aria-expanded
            trigger.setAttribute('aria-expanded', !isHidden);
        };

        // Toggle dropdown on trigger click
        trigger.addEventListener('click', toggleDropdown);

        // Handle keyboard events for accessibility
        trigger.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                toggleDropdown(event);
            }
        });
    });

    // Function to close a specific dropdown
    const closeDropdown = (dropdownData) => {
        const {trigger, content} = dropdownData;
        content.classList.add('hidden');
        trigger.setAttribute('aria-expanded', 'false');
    };

    // Single event listener for closing dropdowns when clicking outside
    document.addEventListener('click', (event) => {
        if (!(event.target instanceof Node)) return;

        dropdownMap.forEach((dropdownData, container) => {
            if (!container.contains(event.target)) {
                closeDropdown(dropdownData);
            }
        });
    });

    // Single event listener for closing dropdowns when pressing escape
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            dropdownMap.forEach((dropdownData) => {
                if (!dropdownData.content.classList.contains('hidden')) {
                    closeDropdown(dropdownData);
                }
            });
        }
    });
}

// Initialize the component when the DOM is ready, deferred to idle time
document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', () => deferToIdle(initDropdown))
    : deferToIdle(initDropdown);
